import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Clientes from './pages/Clientes';
import Usuarios from './pages/Usuarios';
import Precos from './pages/Precos';
import Parametros from './pages/Parametros';
import Despesas from './pages/Despesas';
import Contatos from './pages/Contatos';
import PastaCliente from './pages/PastaCliente';
import PautaConsultar from './pages/PautaConsultar';
import PautaProspeccao from './pages/PautaProspeccao';
import PautaAndamento from './pages/PautaAndamento';
import PautaRegistro from './pages/PautaRegistro';
import PautaFinanceiro from './pages/PautaFinanceiro';
import PautaFinalizado from './pages/PautaFinalizado';
import Reembolsos from './pages/Reembolsos';

function RotaProtegida({ children }) {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<RotaProtegida><Dashboard /></RotaProtegida>} />
        <Route path="/clientes" element={<RotaProtegida><Clientes /></RotaProtegida>} />
        <Route path="/clientes/:clienteId/pasta" element={<RotaProtegida><PastaCliente /></RotaProtegida>} />
        <Route path="/usuarios" element={<RotaProtegida><Usuarios /></RotaProtegida>} />
        <Route path="/precos" element={<RotaProtegida><Precos /></RotaProtegida>} />
        <Route path="/parametros" element={<RotaProtegida><Parametros /></RotaProtegida>} />
        <Route path="/despesas" element={<RotaProtegida><Despesas /></RotaProtegida>} />
        <Route path="/contatos" element={<RotaProtegida><Contatos /></RotaProtegida>} />
        <Route path="/pauta/consultar" element={<RotaProtegida><PautaConsultar /></RotaProtegida>} />
        <Route path="/pauta/prospeccao" element={<RotaProtegida><PautaProspeccao /></RotaProtegida>} />
        <Route path="/pauta/andamento" element={<RotaProtegida><PautaAndamento /></RotaProtegida>} />
        <Route path="/pauta/registro" element={<RotaProtegida><PautaRegistro /></RotaProtegida>} />
        <Route path="/pauta/financeiro" element={<RotaProtegida><PautaFinanceiro /></RotaProtegida>} />
        <Route path="/pauta/finalizado" element={<RotaProtegida><PautaFinalizado /></RotaProtegida>} />
	<Route path="/reembolsos" element={<RotaProtegida><Reembolsos /></RotaProtegida>} />
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </BrowserRouter>
  );
}